module.exports = __webpack_public_path__ + "img/agedsilver.475f42a9.jpg";